// @ts-nocheck
import React, { FC, useCallback } from 'react';
import flags from 'react-phone-number-input/flags';
import { StyledPhoneInput } from './style';

interface PhoneInputProps {
  name?: string;
  value?: string | null;
  country?: string;
  onChange: (value) => void;
  defaultCountry?: string;
  placeholder?: string;
  countries?: string[];
  icon?: string;
  className?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
}
const PhoneInput: FC<PhoneInputProps> = ({
  name,
  value,
  country,
  onChange,
  defaultCountry,
  placeholder,
  countries,
  icon,
  className,
  style,
  readOnly = false,
}) => {
  const handleChange = useCallback(
    (data: string) => {
      onChange(data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [defaultCountry],
  );

  return (
    <StyledPhoneInput
      name={name}
      icon={icon}
      placeholder={placeholder}
      className={className}
      value={value}
      displayInitialValueAsLocalNumber
      smartCaret
      defaultCountry={defaultCountry}
      country={country}
      flags={flags}
      countries={countries}
      onChange={handleChange}
      style={style}
      readOnly={readOnly}
    />
  );
};

PhoneInput.defaultProps = {
  icon: 'phone',
  defaultCountry: 'AU',
  country: 'AU',
  countries: ['AU'],
};
export default PhoneInput;
